export default __webpack_public_path__ + "static/media/samsung-logo.f2068caa.svg";